import FooterOne from '../Footer/FooterOne';
import Header from '../Header/HeaderOne';
import { pageTitle } from '../PageTitle';
import React, { useEffect, useMemo, useState } from 'react';
import Preloader from '../Preloader/Preloader';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebase/config';
import useAmateurRatingStore from '../../store/amateurRatingStore';
import ReactPaginate from 'react-paginate';
import '../../assets/sass/Pagination.css'


const AmateurRatingPage = () => {
    pageTitle("AMATEUR RATING")
    const [firstValues, setFirstValues] = useState({ kills: 0, kd: 0, mvp: 0 });
    const [filterState, setFilterState] = useState('mvp');
    const { amateurRating, setAmateurRating, isLoading, setLoading } = useAmateurRatingStore();
    const [searchInputState, setSearchInputState] = useState('');

    const fetchData = async () => {
        setLoading(true);
        try {
            const docRef = doc(db, "rating", "amateurRating");
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const data = docSnap.data().data.map(tour => ({
                    name: tour.player,
                    teamLogo: tour.logo,
                    kills: tour.kills,
                    kd: (tour.kills / tour.matches).toFixed(2),
                    teamName: tour.team,
                    mvp: tour.mvp
                }));

                setAmateurRating(data);
                localStorage.setItem('amateurLastFetchTime', Date.now().toString()); 
                localStorage.setItem('amateurRating', JSON.stringify(data)); 
            }
        } catch (error) {
            console.error('Ошибка при загрузке данных:', error);
        } finally {
            setLoading(false);
        }
    };

    const shouldFetchData = () => {
        const lastFetchTime = localStorage.getItem('amateurLastFetchTime');
        const currentTime = Date.now();
        const twelveHoursInMillis = 12 * 60 * 60 * 1000; // 12 часов в миллисекундах

        return !lastFetchTime || (currentTime - parseInt(lastFetchTime)) > twelveHoursInMillis;
    };

    useEffect(() => {
        const storedAmateurRating = localStorage.getItem('amateurRating');
        if (shouldFetchData()) {
            fetchData(); 
        } else if (storedAmateurRating) {
            setAmateurRating(JSON.parse(storedAmateurRating));
            setLoading(false)
        }
    }, []); 

    useEffect(() => {
        if (amateurRating.length > 0) {
            const sortedByMVP = [...amateurRating].sort((a, b) => b.mvp - a.mvp);
            const sortedByKills = [...amateurRating].sort((a, b) => b.kills - a.kills);
            const sortedByKD = [...amateurRating].sort((a, b) => b.kd - a.kd);

            const newFirstValues = {
                kills: sortedByKills[0]?.kills || 0,
                kd: sortedByKD[0]?.kd || 0,
                mvp: sortedByMVP[0]?.mvp || 0
            };

            if (
                newFirstValues.kills !== firstValues.kills ||
                newFirstValues.kd !== firstValues.kd ||
                newFirstValues.mvp !== firstValues.mvp
            ) {
                setFirstValues(newFirstValues);
            }

            if (JSON.stringify(sortedByMVP) !== JSON.stringify(amateurRating)) {
                setAmateurRating(sortedByMVP);
            }
        }
    }, [amateurRating]); 

    const filteredRating = useMemo(() => {
        return amateurRating.filter(el => el.name.toLowerCase().includes(searchInputState.trim().toLowerCase()));
    }, [amateurRating, searchInputState]);

    const sortedRating = useMemo(() => {
        return [...filteredRating].sort((a, b) => {
            if (filterState === 'kills') return b.kills - a.kills;
            if (filterState === 'k/d') return b.kd - a.kd;
            return b.mvp - a.mvp;
        });
    }, [filteredRating, filterState]);

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 9;

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
        window.scrollTo(0, 0)
    };

    const offset = currentPage * itemsPerPage;
    const currentItems = sortedRating.slice(offset, offset + itemsPerPage);
    const pageCount = Math.ceil(sortedRating.length / itemsPerPage);

    return <>
        {
            !isLoading ? <>
                <Header></Header>
                    <div className="services__page section-padding">
                        <div className="container">
                            <div className="row mb-30">
                                <div className="col-xl-6 col-lg-8">
                                    <div style={{marginBottom: '20px'}} className="services__page-title lg-t-center">
                                        <span className="subtitle">rating</span>
                                        <h2>Amateur rating</h2>
                                    </div>
                                    <div className="services__page-title lg-t-center">
                                        <h2>Selected filter - {filterState}</h2>
                                    </div>
                                    <div className="services__page-title lg-t-center">
                                        <button style={{marginRight: '10px'}} onClick={() => setFilterState('mvp')}>MVP</button>
                                        <button style={{marginRight: '10px'}} onClick={() => setFilterState('kills')}>Kills</button>
                                        <button style={{marginRight: '10px'}} onClick={() => setFilterState('k/d')}>KD</button>
                                    </div>
                                </div>
                                <div style={{marginTop: '8px', marginBottom: '8px'}} >
                                    <p>Search</p>
                                    <input placeholder='NickName' style={{backgroundColor: 'transparent'}} type="text" value={searchInputState} onChange={e => setSearchInputState(e.target.value)} />
                                </div>
                                <ReactPaginate
                                    previousLabel={'<'}
                                    nextLabel={'>'}
                                    breakLabel={'..'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={2}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination-tme'}
                                    activeClassName={'active'}
                                    disabledClassName={'disabled'}
                                />
                            </div>
                            <div className="row">
                                {currentItems.map((item, id)=>(
                                    <>
                                        <div className="col-xl-12" key={id}>
                                            <div className="services__page-item media-rating-container">
                                                <div className="services__page-item-left">
                                                    <p style={{marginRight: '20px'}}>{id + 1}</p>
                                                    <div className="services__page-item-left-icon">
                                                        <img src={item.teamLogo == '' ? '/images/cup.svg' : item.teamLogo == 'none' ? '/images/cup.svg' : item.teamLogo} alt="" />
                                                    <div className="services__area-item-icon-one">
                                                        <img src={item.imageLink == '' ? '/images/cup.svg' : item.imageLink == 'none' ? '/images/cup.svg' : item.imageLink} alt="" />
                                                    </div>
                                                    </div>
                                                    <div className="services__page-item-left-content">
                                                        <h4><p>{item.name}</p></h4>
                                                    </div>
                                                </div>
                                                <div className='pr-card-box'>
                                                    <div className="pr-carg-rating-container">
                                                        <p>MVP - {item.mvp}</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: (item.mvp / firstValues.mvp) * 100 < 25 ? "red" : (item.mvp / firstValues.mvp) * 100 < 75 ? '#ffc800' : (item.mvp / firstValues.mvp) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${(item.mvp / firstValues.mvp) * 100}%` }}></div>
                                                        </span>
                                                    </div>
                                                    <div className="pr-carg-rating-container">
                                                        <p>Kills - {item.kills}</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: (item.kills / firstValues.kills) * 100 < 25 ? "red" : (item.kills / firstValues.kills) * 100 < 75 ? '#ffc800' : (item.kills / firstValues.kills) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${(item.kills / firstValues.kills) * 100}%` }}></div>
                                                        </span>
                                                    </div>
                                                    <div className="pr-carg-rating-container">
                                                        <p>K/D - {(item.kd / item.kd).toFixed(2)}</p>
                                                        <span className="pr-card-rating-stick">
                                                            <div style={{ backgroundColor: ((item.kd / item.kd) / firstValues.kd) * 100 < 25 ? "red" : ((item.kd / item.kd) / firstValues.kd) * 100 < 75 ? '#ffc800' : ((item.kd / item.kd) / firstValues.kd) * 100 < 100 ? 'rgb(3 253 69)' : 'rgb(3 253 69)', height: '100%', width: `${((item.kd / item.kd) / firstValues.kd) * 100}%` }}></div>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="services__page-item-right">
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>
                <FooterOne></FooterOne>        
            </> : <Preloader />
        }
    </>;
};

export default AmateurRatingPage;